// key must equal value in this enum

export enum DefaultAtoms {
  PersonalUserData = "PersonalUserData",
  FrontendConfig = "FrontendConfig",
  ApiTokens = "ApiTokens",
}
